import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import ElevatedNumericInput from '../../../components/Basic/ElevatedNumericInput';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('lg')]: {
      maxWidth: 350,
    },

    // '&.MuiGrid-item': {
    //   paddingLeft: 16,
    // },
  },
}));

const BaseLimitOrderTimeoutSeconds = ({
  name = '',
  label = '',
  className = '',
  error = false,
  helperText = '',
  disabled = false,
  value,
  onChange = () => {},
  onBlur = () => {},
  placeholder = '',
}) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} lg={6} className={`${classes.root} ${className}`}>
      <ElevatedNumericInput
        label={label}
        disabled={disabled}
        name={name}
        error={error}
        helperText={helperText}
        value={value}
        suffix=" secs"
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
      />
    </Grid>
  );
};

export default BaseLimitOrderTimeoutSeconds;
